import { useToastStore, type ToastKind } from '@/stores/toast';
import { cn } from '@/lib/utils';
import { commonT } from '@/i18n';
import { shellT } from '@/i18n/messages/shell';

/// Toaster global — renderiza a fila de toasts do `useToastStore` no canto
/// inferior. Montado uma vez na raiz (`App.tsx`). Mobile-first: ocupa largura
/// da tela em <sm e fica auto à direita em ≥sm.
export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  if (toasts.length === 0) return null;

  return (
    <div
      role="region"
      aria-label={shellT().toastRegion}
      className="fixed inset-x-2 bottom-2 z-[100] flex flex-col gap-2 sm:left-auto sm:right-4 sm:bottom-4 sm:max-w-sm"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          role={t.kind === 'error' ? 'alert' : 'status'}
          className={cn(
            'rounded-md border shadow-md px-3 py-2.5 text-sm bg-background',
            'flex items-start gap-2',
            kindClass(t.kind),
          )}
        >
          <div className="flex-1 min-w-0">
            <p className="font-medium leading-tight">{t.title}</p>
            {t.description ? (
              <p className="text-xs text-muted-foreground mt-1 break-words">
                {t.description}
              </p>
            ) : null}
          </div>
          <button
            type="button"
            onClick={() => dismiss(t.id)}
            aria-label={commonT().close}
            className="text-muted-foreground hover:text-foreground -mt-0.5 -mr-1 px-2 leading-none text-lg"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}

function kindClass(kind: ToastKind): string {
  switch (kind) {
    case 'error':
      return 'border-destructive/40 bg-destructive/5';
    case 'success':
      return 'border-emerald-500/40 bg-emerald-500/5';
    case 'info':
    default:
      return 'border-border';
  }
}
